import { NavStateToggler } from '@app/components/layout/sidenav/footer/NavStateToggler';
import { Box } from '@mui/material';
import { NavSeparator } from '../base';

/**
 * Pinned sidenav footer: faint divider + collapse toggle as a dedicated control zone
 * below the scrolling nav list.
 */
export function NavFooter() {
  return (
    <Box
      sx={{
        marginTop: 'auto',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.75,
        pb: 1.25,
        pt: 0.5,
      }}
    >
      <NavSeparator sx={{ my: 0 }} />
      <NavStateToggler />
    </Box>
  );
}
